import React from "react";

export const FormRow = ({ children, ...props }) => (
  <div className="row" {...props}>
    {children}
  </div>
);
